import React from 'react';
import { ConfigProvider, DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';

const { RangePicker } = DatePicker;

const BaseRangePicker = (props: RangePickerProps) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          controlHeight: 56,
          borderRadius: 5,
        },
        components: {
          DatePicker: {
            fontSize: 18,
            fontWeightStrong: 500,
            colorText: '#505050',
          },
        },
      }}
    >
      <RangePicker {...props} />
    </ConfigProvider>
  );
};

export default BaseRangePicker;
